import { useFrameworkSuppliersExport } from "lib/hooks/api/frameworks/useFrameworkSupplierExport";
import { EventDataTypes } from "lib/tracking";
import { ExportButtonGraphql } from "../actions/ExportButtonGraphql";

export default function ExportFrameworkSuppliersButton({
  frameworkId,
  selectedSupplierGuids,
  totalResults,
  isLoading,
}: {
  frameworkId: string;
  totalResults: number;
  selectedSupplierGuids: string[];
  isLoading: boolean;
}) {
  const frameworkExportMutation = useFrameworkSuppliersExport();

  return (
    <ExportButtonGraphql
      isLoadingTotalResults={isLoading}
      totalResults={selectedSupplierGuids.length > 0 ? selectedSupplierGuids.length : totalResults}
      exportMutation={frameworkExportMutation}
      exportVariables={{
        frameworkId,
        selectedSupplierGuids,
      }}
      exportDataType={EventDataTypes.supplier}
    />
  );
}
